import { AuthService } from 'src/app/services/auth.service';
import { ToastController } from '@ionic/angular';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import * as moment from 'moment';
import { BookingService } from 'src/app/services/booking.service';
import { EventService } from 'src/app/services/event.service';
import { EventtypeService } from 'src/app/services/eventtype.service';
import { environment } from 'src/environments/environment';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectCards, EffectCube, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { QuestionService } from 'src/app/services/question.service';
import { CompanyService } from 'src/app/services/company.service';
import { Company } from 'src/app/interfaces/company';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-wizard-event',
  templateUrl: './wizard-event.page.html',
  styleUrls: ['./wizard-event.page.scss'],
})
export class WizardEventPage implements OnInit {

  private form: FormGroup;

  public isCustomer: boolean = false;

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    // preventInteractionOnTransition: true,

    //rene ////////////////////////////////////////////////7
    // rene zum aus und einschalten vom Swiper links rechtsionic serve
    //rene ////////////////////////////////////////////////7
    allowSlideNext: true,
    allowSlidePrev: true,
    pagination: { clickable: true }, //Punkte unten
  };

  inIframe: boolean = true;

  pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  }
  events: any;
  company: Company;
  locations: any[];
  touchAllowed: boolean = false;
  ispagination: boolean = false;
  selectDate: string;
  chosenDate: any;
  selectDay: string;
  chosenDay: any;
  selectTime: string;
  chosenTime: any;

  locationId: any;
  selectLocation: any;
  filteredEvents: any;
  filteredDates: any[] = [];
  filteredDays: any[] = [];
  //filteredDateTimes: any[] = [];
  filteredDateTimes: BehaviorSubject<any[]> = new BehaviorSubject([]);

  eventType: any[] = [];
  name: any;
  selectedEventtype: any = "";
  serviceIFrame: any;
  isSubmitted = false;
  swiperindex: number = 0;
  question: any;
  fuckFrage: any;
  eventText: string = "";
  eventText2: string = "";
  locationText: string = "";
  locationText2: string = "";
  dateText: string = "";
  dateText2: string = "";
  nameText: string = "";
  nameText2: string = "";
  busy: boolean = false;
  manyTimeElements: boolean = false;
  chosenEvent: string = "";

  constructor(
    private changeDetection: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private storage: Storage,
    private bookingService: BookingService,
    private eventTypeService: EventtypeService,
    private toastCtrl: ToastController,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private questionService: QuestionService,
    private compService: CompanyService
  ) {
    this.form = this.formBuilder.group({
      name: ["", [Validators.required, Validators.minLength(2)]],
      email: ["", [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      description: ['',],
    })
  }

  async ngOnInit() {
    // Read target company from route param, and use token (own) company if ID is "self"
    const { id } = this.activatedRoute.snapshot.params;
    this.isCustomer = id !== 'self';

    // User token company or param company depending on if the actor is a customer
    const token = await this.getAppropriateToken();
    const companyId = this.isCustomer ? id : token.company;

    if (window.location !== window.parent.location) {
      this.inIframe = true;
      this.serviceIFrame = await this.storage.get(environment.storage.serviceIFrame);

    } else {
      this.inIframe = false;
      // The page is not in an iframe
    }
    this.busy = true;
    if (this.swiper) {
      this.swiper.updateSwiper({});
    }

    console.log('Company ID', companyId);
    this.company = await this.compService.getCompanyById(companyId).toPromise();

    this.questionService.getAllQuestions(companyId, this.company.category as string).subscribe(questionList => {
      questionList.forEach(qe => {
        switch (qe.typ) {
          case 'event':
            this.eventText = qe.text;
            this.eventText2 = qe.text2;
            break;
          case 'location':
            this.locationText = qe.text;
            this.locationText2 = qe.text2;
            break;
          case 'date':
            this.dateText = qe.text;
            this.dateText2 = qe.text2;
            break;
          case 'name':
            this.nameText = qe.text;
            this.nameText2 = qe.text2;
            break;
          default:
            break;
        }
      });
      if (!this.eventText)
        this.eventText = "Was möchten Sie gerne buchen?";
      if (!this.locationText)
        this.locationText = "Wo möchten Sie gerne buchen?";
      if (!this.dateText)
        this.dateText = "Wann würden Sie gerne kommen?";
      if (!this.nameText)
        this.nameText = "Auf welchen Namen möchten Sie reservieren?";


      console.log('questionList', questionList);
    });

    this.swiper.swiperRef.allowTouchMove = false;

    // TODO: User token has "fullname", but customer token has NO name
    const { fullname, email } = await this.getAppropriateToken();

    this.form.setValue({ name: fullname || '', email: email, description: "" });
    console.log('Email ', email);

    if (this.company) {
      // Set company colors
      document.documentElement.style.setProperty('--ion-color-primary', this.company.primary_color || 'grey');
      document.documentElement.style.setProperty('--ion-color-secondary', this.company.secondary_color || 'goldenrod');

      this.eventService.getAllEvents(this.company._id).subscribe(async x => {
        this.events = [];
        this.busy = false;
        x.forEach(ev => {
          if (
            (ev.attendees - ev.schedules.length) > 0 &&
            !ev.schedules.some(schedule => schedule.email === email)
          ) {
            this.events.push(ev);
          }
        })

        this.swiper.swiperRef.activeIndex = 0;
        this.locations = [];
        if (this.inIframe) {
          if (this.serviceIFrame) {
            this.initIFrame(this.serviceIFrame)
          }
        }

        this.events.forEach(ev => {
          // TODO: find
          if (ev.service && (!this.eventType.find(l => l._id == ev.service._id))) {//distinct
            this.eventType.push(ev.service);
          }
        });
        console.log('getAllEvents: ', this.events);
      });
    } else {
      console.log('etwas ist schiefgelaufen mit GETALLEVENTS', this.events, '\n', 'companyid: ', this.company);
    }
  }

  private getAppropriateToken(): Promise<any> {
    return this.isCustomer ? this.authService.getDecodedCustomerToken() : this.authService.getDecodedUserToken();
  }

  ngAfterContentChecked(): void {
    // swiper update
    if (this.swiper) {
      this.swiper.updateSwiper({});
    }
    if (this.eventType && this.locations && this.selectDate) {
      this.swiper.swiperRef.allowTouchMove = true;
      this.ispagination = true;
    }
    // SwiperCore.use([EffectCards]);
    // SwiperCore.use([Pagination]);
    SwiperCore.use([Navigation, Pagination, Scrollbar, A11y,]);

    // this.heute = moment(this.todayDate).locale('de').calendar();
    // this.morgen = moment(this.todayDate).locale('de').add(1, 'days').calendar();
    // this.uebermorgen = moment(this.todayDate).locale('de').add(2, 'days').calendar();
    // this.uebermorgen2 = moment(this.todayDate).locale('de').add(3, 'days').calendar();
    // this.uebermorgen3 = moment(this.todayDate).locale('de').add(4, 'days').calendar();
    // this.uebermorgen = moment(this.todayDate).locale('de').format('dddd');
    // this.uebermorgen2 = moment(this.todayDate).locale('de').add(3, 'days').calendar();
    // this.uebermorgen3 = moment(this.todayDate).locale('de').add(4, 'days').calendar();
  }

  get errorControl() {
    return this.form.controls;
  }

  submitForm() {
    this.isSubmitted = true;
    if (!this.form.valid) {
      console.log('Please provide all the required values!')
      return false;
    } else {
      this.saveBooking()
      console.log(this.form.value)
    }
  }

  checkTime(minDuration) {
    const d = Math.floor(minDuration * 60 / (3600 * 24));
    const h = Math.floor(minDuration * 60 % (3600 * 24) / 3600);
    const m = Math.floor(minDuration * 60 % 3600 / 60);
    if (d > 0) {
      if (d === 1) {
        return d + " Tag " + h + " Stunden " + m + " Minuten"
      }
      else {
        return d + " Tage " + h + " Stunden " + m + " Minuten"
      }

    }
    else {
      if (h > 0) {
        if (h === 1 && m > 0) {
          return h + " Stunde " + m + " Minuten"
        }
        if (h === 1 && m == 0) {
          return h + " Stunde "
        }
        else {
          if (m > 0) {
            return h + " Stunden " + m + " Minuten"
          }
          else {
            return h + " Stunden "
          }
        }
      }
      else {
        return m + " Minuten"
      }


    }
  }



  getDateTimeStart(date) {
    const offset = new Date().getTimezoneOffset()
    return moment(new Date(date.date)).add("minutes", offset).format("DD.MM.YYYY HH:mm")
  }

  getDateTimeEnd(date) {
    const offset = new Date().getTimezoneOffset()
    return moment(new Date(date.end_date)).add("minutes", offset).format("DD.MM.YYYY HH:mm")
  }

  getDateTimeStartDate(date) {
    const offset = new Date().getTimezoneOffset()
    return moment(new Date(date.date)).add("minutes", offset).format("DD.MM.YYYY")
  }

  getDateTimeEndDate(date) {
    const offset = new Date().getTimezoneOffset()
    return moment(new Date(date.end_date)).add("minutes", offset).format("DD.MM.YYYY")
  }

  getDateTimeStartTime(date) {
    const offset = new Date().getTimezoneOffset()
    return moment(new Date(date.date)).add("minutes", offset).format("HH:mm")
  }

  getDateTimeEndTime(date) {
    const offset = new Date().getTimezoneOffset()
    return moment(new Date(date.end_date)).add("minutes", offset).format("HH:mm")
  }

  eventtypeChange(eventtype) {
    this.locations = [];
    this.selectedEventtype = eventtype;
    // console.log("THIS.LOCATIONS: ", this.locations)

    const filteredEvents = this.events.filter(ev => ev.service._id === this.selectedEventtype._id);
    console.log("EVENTS: ", this.events)
    filteredEvents.forEach(ev => {
      if (ev.location && (!this.locations.find(l => l._id == ev.location._id))) {
        this.locations.push(ev.location);
        // console.log("Location found: ", ev.location);
      }
      // console.log("All Locations found: ", this.locations);
    });
    // TODO: alle locations mit diesem datatype
    // console.log("DATATYPE: ", eventtype);
    // let eventtypes = this.events.filter(dt => dt.service._id === datatype._id);
    this.locations.forEach(x => {
      console.log(x);
    })
    // console.log('FILTEREDEVENT: ', this.locations);
    this.swiper.swiperRef.slideNext(1000);
    this.changeDetection.detectChanges();
  }

  //todo SERVICE AUSWÄHLEN
  locationChange(location) {
    this.filteredDates = [];
    console.log("location: ", location);
    this.locationId = location._id;
    this.selectLocation = location.fullname
    this.filteredEvents = this.events.filter(ev => ev.location?._id === this.locationId && ev.service._id === this.selectedEventtype._id && new Date(ev.start_date).getTime() > new Date().getTime());
    // this.filteredDates = this.filteredEvents.map(ev => ev.start_date);

    this.filteredEvents.forEach(event => {
      let free = event.attendees - event.schedules.length;
      if (free > 0) {
        this.filteredDates.push({ date: event.start_date, free: free, end_date: event.end_date, id: event._id });
      }
      else {
        this.filteredDates.push({ date: event.start_date, free: "keine", end_date: event.end_date, id: event._id });
      }
    });

    this.manyTimeElements = (this.filteredDates.length > 10); // 10 if many elements separate day and time
    if (this.manyTimeElements) {
      this.filteredDates.forEach(event => {
        //console.log("event check:" + event.date);
        //let free = event.attendees - event.schedules.length;
        let checkDate = this.getDateTimeStartDate(event);
        let found = false;
        this.filteredDays.forEach(day => {
          if (day.day === checkDate) {
            found = true;
            //exit;
          }
        });
        if (!found) {
          this.filteredDays.push({ day: checkDate, date: event.date });
          //console.log("day add:" + checkDate);
        }

        // if (free > 0) {
        //   this.filteredDays.push({ day: this.getDateTimeStartDate(event.start_date), free: free });
        // }
        // else {
        //   this.filteredDays.push({ day: this.getDateTimeStartDate(event.start_date), free: "keine" });
        // }
      });
      this.filteredDays.sort(function (x, y) {
        if (x.date > y.date) {
          return 1;
        }

        if (x.date < y.date) {
          return -1;
        }
        return 0;
      });
      console.log("many day elements:" + this.filteredDays.length);
      console.log("days found:", this.filteredDays);
    }
    else {
      console.log("few elements:" + this.filteredDates.length);
      this.sortByDateAsc(this.filteredDates);
    }


    this.swiper.swiperRef.slideNext(1000);
    this.changeDetection.detectChanges();
    console.log("FILTERED EVENTS: ", this.filteredEvents);
  }

  sortByDateAsc(array) {
    array.sort((adate, bdate) => {
      if (adate > bdate) {
        return 1
      }
      if (adate < bdate) {
        return -1
      }
      else {
        return 0
      }
    });
  }

  async logout() {
    this.storage.clear();
    // await this.authService.logout();
    // this.router.navigate(["clogin"])
    this.router.navigate(["clogin?id=" + this.company._id + "&service=" + this.selectedEventtype._id]);
  }

  //todo DATE AUSWÄHLEN
  dateSelect(termindate) {
    const offset = new Date().getTimezoneOffset();
    this.selectDate = moment(termindate.date).add("minutes", offset).locale('de').format('LLL');
    this.chosenDate = termindate.date;
    console.log("CHOSENDATE: ", this.chosenDate);
    console.log("SELECTDATE: ", this.selectDate);
    console.log("FILTERED EVENTS: ", this.filteredEvents);
    this.swiper.swiperRef.slideNext(1000);
    this.changeDetection.detectChanges();
  }

  daySelect(terminday) {
    //const offset = new Date().getTimezoneOffset();
    //this.selectDate = moment(termindate.date).add("minutes", offset).locale('de').format('LLL');
    this.chosenDay = terminday;
    console.log("CHOSENDAY: ", this.chosenDay);
    this.filteredDateTimes = new BehaviorSubject([]);
    this.filteredDates.forEach(event => {
      let checkDate = this.getDateTimeStartDate(event);
      if (checkDate === this.chosenDay.day) {
        //this.filteredDateTimes.push({ time: this.getDateTimeStartTime(event)});
        this.addData({ time: this.getDateTimeStartTime(event), date: event.date, event: event.id });
        //console.log("day add:" + checkDate);
      }
    });
    console.log("SELECTABLE TIMES: ", this.filteredDateTimes.getValue());
    this.changeDetection.detectChanges();
  }

  addData(foo: any): void {
    //this.filteredDateTimes.next([...this.filteredDateTimes.getValue(), ...foo]);
    this.filteredDateTimes.next([...this.filteredDateTimes.getValue(), foo]);
  }

  timeSelect(termintime) {
    const offset = new Date().getTimezoneOffset();
    this.selectDate = moment(termintime.date).add("minutes", offset).locale('de').format('LLL');
    this.chosenTime = termintime;
    this.chosenDate = termintime;
    this.chosenEvent = termintime.event;
    console.log("CHOSENDATE: ", this.chosenDate);
    //console.log("CHOSENTime: ", this.chosenTime);
    this.swiper.swiperRef.slideNext(1000);
    this.changeDetection.detectChanges();

  }

  saveBooking() {
    // TODO: save Event with BookingService new Date(ev.start_date).getTime() === new Date(this.chosenDate).getTime() && ev.location._id === this.locationId
    let foundEvent;
    if (this.chosenEvent !== "") {
      foundEvent = this.events.find(ev => { return ev._id === this.chosenEvent });
      console.log("EVENT FOUND: ", foundEvent);
    } else {
      foundEvent = this.events.find(ev => { return new Date(ev.start_date).getTime() === new Date(this.chosenDate).getTime() && ev.location._id === this.locationId });
      console.log("EVENT FOUND: ", foundEvent);
    }
    const eventToSave = {
      event: foundEvent._id,
      email: this.form.value.email,
      company: this.company._id,
      name: this.form.value.name,
    }
    this.bookingService.addBooking(this.company._id, eventToSave).subscribe(res => {
      // console.log("booking: ", res)
      console.log("EVENT FOUND: ", foundEvent);
      if (foundEvent.schedules.length > 0) {
        if (typeof foundEvent.schedules[0] != "string") {
          foundEvent.schedules = foundEvent.schedules.map(s => s._id);
        }
      }
      const finalEvent = { ...foundEvent }
      foundEvent.schedules.push(res._id);
      console.log("EVENT FOUND: ", foundEvent);
      this.eventService.editEvent(foundEvent).subscribe(async x => {
        console.log("EVENT FOUND: ", finalEvent);
        //TODO Email notification
        console.log("NOTIFYING CUSTOMER");

        console.log("ALL EVENTS: ", this.events)
        this.eventService.notifyCustomerBookingSuccess(this.form.value.email, finalEvent, res._id).subscribe(res => {
          console.log("CUSTOMER NOTIFIED SUCCESSFULLY: ", res);
        }, err => {
          console.log("ERROR ON NOTIFYING CUSTOMER: ", err);
        })
        console.log('editEvent geht')
        if (!this.isCustomer) {
          this.router.navigate(['folder/Kalender']);
        }
        else {
          const toast = await this.toastCtrl.create({
            message: "Der Termin wurde erfolgreich gebucht. Sie haben eine Email erhalten!",
            duration: 3000,
            position: 'bottom'
          });
          toast.present();
          this.swiper.swiperRef.activeIndex = 0;

        }

      }, err => {
        console.log('editEvent geht nicht')

      })
      console.log('EVENT+++++++++++++++++++:', event);
      this.resetSwiper();
    }, err => {
      console.log(err)
    });


    // TODO: Termin buchen auf DB mit Email
  }



  goToEventType() {
    // BESCHREIBUNG: swipe auf Step Date
    this.swiper.swiperRef.activeIndex = 0;
  }
  goToLoc() {
    // BESCHREIBUNG: swipe auf Step Date
    this.swiper.swiperRef.activeIndex = 1;
  }

  goToDate() {
    // BESCHREIBUNG: swipe auf Step Date
    this.swiper.swiperRef.activeIndex = 2;
  }

  // ///////////////////////////////////////
  // Weiter bei Wizard
  // ///////////////////////////////////////
  slideNext() {
    this.swiper.swiperRef.slideNext(500);
    console.log("NEXT: ", this.swiper);

  }

  // ///////////////////////////////////////
  // Zurück bei Wizard
  // ///////////////////////////////////////
  slidePrev() {
    this.swiper.swiperRef.slidePrev(500);
    console.log("PREV: ", this.swiper);
  }

  // ///////////////////////////////////////
  // Wizard touch auschalten
  // ///////////////////////////////////////
  toggleTouch() {
    this.touchAllowed = !this.touchAllowed;
    this.ispagination = !this.ispagination;
    this.swiper.swiperRef.allowTouchMove = this.touchAllowed;
    console.log("touchAllowed: ", this.touchAllowed);
  }

  formatDate(date) {
    return moment(date).format("DD.MM.YYYY");
  }

  swiperSlideChanged(event) {
    console.log("SWIPERCHANED", event[0].activeIndex)
    this.swiperindex = event[0].activeIndex;
  }

  back() {
    // this.router.initialNavigation()
    // this.router.navigateByUrl('folder/Kalender');
    this.router.navigate(['folder/Kalender']);
    this.resetSwiper();
  }

  newBooking() {
    this.resetSwiper();
  }

  private resetSwiper() {
    this.selectedEventtype = "";
    this.selectLocation = null;
    this.selectDate = null;
    this.locationId = null;
    this.chosenDate = null;
    this.chosenTime = null;
    this.locations = [];
    this.swiper.swiperRef.activeIndex = 0;
  }

  initIFrame(eventtype) {
    this.selectedEventtype = eventtype
    console.log("EVENTTYPE: ", eventtype)
    this.locations = []
    // this.selectedEventtype = eventtype._id;
    this.selectedEventtype = eventtype
    console.log("THIS.LOCATIONS: ", this.locations)
    console.log("EVENTS: ", this.events)
    const filteredEvents = this.events.filter(ev => ev.service._id === this.selectedEventtype._id);

    filteredEvents.forEach(ev => {
      if (ev.location && (!this.locations.find(l => l._id == ev.location._id))) {
        this.locations.unshift(ev.location);
        console.log("Location found: ", ev.location);
      }
      console.log("All Locations found: ", this.locations);
    });
    // TODO: alle locations mit diesem datatype
    console.log("DATATYPE: ", eventtype);
    // let eventtypes = this.events.filter(dt => dt.service._id === datatype._id);
    this.locations.forEach(x => {
      console.log(x);
    })
    console.log('FILTEREDEVENT: ', this.locations);
  }
}
